































































import { Prop, Component, Vue } from "vue-property-decorator";

import Action from "../models/action";
import Chart from "../models/chart";
import ChartRow from "../models/chart-row";
import ChartBar from "../models/chart-bar";
import ChartHeader from "../models/chart-header";

import VChart from "@/components/chart/VChart.vue";
import VChartRow from "@/components/chart/VChartRow.vue";
import VChartBody from "@/components/chart/VChartBody.vue";
import VToolbar from "@/components/VToolbar.vue";
import VProxyWindow from "@/components/VProxyWindow.vue";
import VChartHeader from "../components/chart/VChartHeader.vue";
import { isWeekend } from "date-fns";
import { GridMask } from "../viewmodels/grid-mask";
import ScheduleViewModel from "../ui/schedule/presenters/schedule";
import Schedule from "@/ui/schedule/components/Schedule.vue";

@Component({
  components: {
    VChart,
    VChartRow,
    VChartBody,
    VChartHeader,
    VToolbar,
    VProxyWindow,
    Schedule
  }
})
export default class ProjectChartTemplate extends Vue {
  @Prop({ required: true }) toolbarActions!: Action[];
  @Prop({ required: true }) chart!: Chart;
  @Prop({ required: true }) rows!: ChartRow[];
  @Prop({ required: true }) chartHeader!: ChartHeader;
  @Prop({ type: Boolean }) readonly!: boolean;
  @Prop({ type: Boolean }) rowAppendable!: boolean;
  @Prop({ required: true }) scheduleCalendars!: ScheduleViewModel[];

  get chartMask(): GridMask {
    return {
      cols: this.chartHeader.days.map(d =>
        isWeekend(d) ? { color: "rgba(0, 0, 0, 0.025)" } : {}
      )
    };
  }

  select(bar: ChartBar) {
    this.$emit("selectTask", bar.id);
  }

  change(newBar: ChartBar) {
    this.$emit("moveTask", newBar);
  }

  submit() {
    this.$emit("submitTaskMove");
  }

  cancel() {
    this.$emit("cancelTaskMove");
  }

  clickScheduleCell(userId: number, date: Date) {
    this.$emit("clickScheduleCell", userId, date);
  }

  goNext(e: Event) {
    this.$emit("goNext", e);
  }

  goPrev(e: Event) {
    this.$emit("goPrev", e);
  }

  toggleHeaderType() {
    this.$emit("toggleHeaderType");
  }

  newTask(rowIndex: number, colIndex: number) {
    const row = this.rows[rowIndex];
    const start = this.chartHeader.days[colIndex];
    this.$emit("newTask", row.id, start);
  }

  sort(rows: ChartRow[]) {
    this.$emit("sortTaskGroups", rows.map(r => r.id));
  }

  swipeHandler(e: String) {
    if (window.screen.availWidth > 768) return;
    if (e === "right") {
      this.$emit("goPrev");

      return;
    }
    this.$emit("goNext");
  }
}
